import React from 'react';

import Image from 'next/image';

import {
  Box,
  Button,
  Hidden,
  Typography
} from '@mui/material';

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';


import gaEvent from '../../lib/gaEvent';


const WelcomeSteps = ({ handleNextStep }) => {
  
  const start = () => {
    gaEvent({
      category: 'Request Quotes',
      action: 'Click Start',
      label: 'Start',
    });

    handleNextStep(0);
  }

  const StepBox = ({ src, text, subText }) => {
    return (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        textAlign="center"
        mx={3}
      >
        <Box>
          <Image
            src={src}
            width={200}
            height={200}
            alt={subText}
            title={subText}
          />
        </Box>
        <Box color="#fff">
          <Typography variant="h6" sx={{ mt: 2 }}>
            {text}
          </Typography>
          <Typography variant="h6">{subText}</Typography>
        </Box>
      </Box>
    );
  };

  const StepBoxCarousel = ({ src, text, subText }) => {
    return (
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        textAlign="center"
      >
        <Box>
          <Image
            src={src}
            width={200}
            height={200}
            alt={subText}
            title={subText}
          />
        </Box>
        <Box color="primary.light" fontSize={16} fontWeight={900} mt={2}>
          <Typography variant="inherit" component="p">
            {text}
          </Typography>
        </Box>
        <Box color="primary.main">
          <Typography variant="h4">{subText}</Typography>
        </Box>
      </Box>
    );
  };

  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return <>
    <Box
      sx={{
        display: {
          xs: 'block',
          md: 'none',
        },
        width: '100%',
        position: 'relative',
        pb: 4.5,
        '& > li': {
          '&.react-multi-carousel-dot--active': {
            '& > button': {
              backgroundColor: 'primary.light',
            },
          },
          '& > button': {
            borderColor: 'primary.light',
            borderWidth: 1,
          },
        },
      }}
    >
      <Carousel
        ssr={true}
        responsive={responsive}
        infinite={true}
        keyBoardControl={false}
        arrows={false}
        showDots={true}
        renderDotsOutside={true}
        autoPlay={true}
        autoPlaySpeed={5000}
      >
        <StepBoxCarousel src="/icons/choose-a-car.svg" text="STEP 1" subText="Select a car" />
        <StepBoxCarousel
          src="/icons/choose-a-service.svg"
          text="STEP 2"
          subText="Select a service"
        />
        <StepBoxCarousel
          src="/icons/receive-an-estimate.svg"
          text="STEP 3"
          subText="Receive an estimate"
        />
        <StepBoxCarousel src="/icons/request-quotes.svg" text="STEP 4" subText="Request quotes" />
      </Carousel>
    </Box>

    <Box
      sx={{
        display: {
          xs: 'none',
          md: 'flex',
        },
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <StepBox src="/icons/choose-a-car.svg" text="STEP 1" subText="Select a car" />
      <StepBox src="/icons/choose-a-service.svg" text="STEP 2" subText="Select a service" />
      <StepBox
        src="/icons/receive-an-estimate.svg"
        text="STEP 3"
        subText="Receive an estimate"
      />
      <StepBox src="/icons/request-quotes.svg" text="STEP 4" subText="Request quotes" />
    </Box>

    <Box mt={{ xs: 4, md: 8 }}>
      <Button
        variant="contained"
        color="secondary"
        size="large"
        onClick={() => {
          start();
        }}
      >
        Let&apos;s Get Started
      </Button>
    </Box>
  </>;
};

export default WelcomeSteps;
